import { InjectionToken } from "@angular/core";
import { Menu } from "@core/menu/_types";


export const MENU = new InjectionToken<Menu>("MENU");
